<template>
  <div class="">
    <div :class="wrapperClasses">

      <h2 class="h3">
        <slot name="title">{{title}}</slot>
      </h2>

      <div
        v-if="$slots['title-description']"
        class="application-section__title-description print-hide mb-ts-1"
      >
        <slot name="title-description">
        </slot>
      </div>

      <div
        class="application-section__sub-grid"
        v-if="$slots['default'] || $slots['sidebar']"
      >

        <!-- If there is no sidebar make section 1 full width -->
        <div class="" :class="{'flex-1' : ! $slots.sidebar }">
          <slot></slot>
        </div>

        <!-- This is used rarely -->
        <div class="application-section__sidebar" v-if="$slots.sidebar">
          <slot name="sidebar"></slot>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: '',
      },
      wrapperClasses: {
        type: String,
        default: '',
      }
    },
  }
</script>

<style lang="scss">
  @import "~styles/definitions";

  .application-section {
  }

  .application-section__grid {
    padding: r(24);
    background-color: $color-green-lighter-2025;
    @include media-breakpoint-up(xl) {
      display: flex;
    }
  }

  .application-section__column-title {
    @include media-breakpoint-up(xl) {
      flex: 1;
      max-width: r(208);
      margin-right: r(32);
    }
    @media print {
      padding-top: r(20);
    }
  }

  .application-section__title {
    @include font-h-22;
  }

  .application-section__title-description {
    @include font-body-16;
    margin-top: r(8);
  }

  .application-section__sub-grid {
    margin-top: r(16);

    @include media-breakpoint-up(lg) {
      flex: 1;
      display: flex;
    }

    @include media-breakpoint-up(xl) {
      margin-top: 0;
    }
  }

  .application-section__middle {
    @include media-breakpoint-up(lg) {
      flex: 2;
    }
  }

  .application-section__sidebar {
    @include media-breakpoint-up(lg) {
      flex: 1;
      max-width: r(208);
      margin-left: r(32);
    }
  }
</style>
